import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { AncillaryContentSubtype } from "../../../types/AncillaryContentType";
import { GetSingleAncillaryResponse } from "./GetSingleAncillaryResponse";
import { SearchAncillariesRequest } from "./SearchAncillariesRequest";
import { SearchAncillariesResponse } from "./SearchAncillariesResponse";
import { SuggestAncillaryByTitleResponse } from "./SuggestAncillaryByTitleResponse";

export const useCatalogueAncillarySearchApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.catalogueConfig.apiUrl}/ancillaries/search`;

    const suggestAncillaryByTitle = async (
        title: string,
        contentType: AncillaryContentSubtype,
        airlineId: string
    ): Promise<SuggestAncillaryByTitleResponse> => {
        return httpGet<SuggestAncillaryByTitleResponse>(`${baseUrl}/suggest`, {
            title,
            subtype: contentType,
            airlineId
        });
    };

    const getSingleAncillary = async (ancillaryId: string): Promise<GetSingleAncillaryResponse> => {
        return httpGet<GetSingleAncillaryResponse>(`${baseUrl}/${ancillaryId}`);
    };

    const searchAncillaries = async (request: SearchAncillariesRequest): Promise<SearchAncillariesResponse> => {
        return httpPost<SearchAncillariesResponse>(`${baseUrl}`, request);
    };

    return { suggestAncillaryByTitle, getSingleAncillary, searchAncillaries };
};
